import { Builder } from '@builder.io/react';

import FormContent from './index';

Builder.registerComponent(FormContent, {
  name: 'Sales FormContent',
  inputs: [
    {
      name: 'quote',
      type: 'reference',
      model: 'quotes',
      defaultValue: [
        {
          link: 'scale.com',
          logo: {
            src: 'https://cdn.builder.io/api/v1/image/assets%2Fe0438815ba51486bbb6a202747122d4b%2F7a721c787b4049adb4ff2c7371e3c186',
            alt: 'test image'
          },
          quote: 'this is the quote with a long text for the quote test component'
        }
      ]
    }
  ]
});
